import { merge } from 'ramda/es';

const defaultOptions = data => ({
  /*title: {
        text: 'Pie chart',
      },*/
  data,
  tooltip: {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c} {d}%'
  },
  series: [
    {
      name: 'user :',
      type: 'pie',
      selectedMode: 'single',
      center: '50%',
      label: {
        normal: {
          show: false
        },
        emphasis: {
          show: false
        }
      },
      lableLine: {
        normal: {
          show: false
        },
        emphasis: {
          show: false
        }
      },
      itemStyle: {
        emphasis: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        },
        animationType: 'scale',
        animationEasing: 'elasticOut',
        animationDelay: () => {
          return Math.random() * 200;
        }
      }
    }
  ]
});

export function createPieChart(data, options = {}) {
  return merge(defaultOptions(data), options);
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/charts/pie/pieChart.ts